<mydocma-mm-app-pane-header [text]="headerText$ | async" class="pane-header mm-pane-header"
                            (doneClick)="onDoneClick()" (closeClick)="faultActionsService.onClose()"
                            [doneEnabled]="!((rightPaneService.saving$ | async) || (triggerLoader$ | async))"
                            [doneVisible]="(!(appContainerService.mobileView$ | async) && !isPaneUndocked )"
                            [closeEnabled]="!(rightPaneService.saving$ | async)"
                            [changed]="((changeService.changesPerMask.get(faultRightPane) | async) || (changeService.changesPerMask.get(planRightPane) | async))
  && !(((plansManagerService.selectedPlan$ | async) == null) && planEditService.planEditMode === 3)"
                            [locked]="isLocked">


  <div ap-pane-menu>
    <button mat-icon-button

            [mydocmaMenuTriggerFor]="menu"
            #parentMenuTrigger="mydocmaMenuTrigger"
            *ngIf="fault && fault.changeState?.status !== changeStatus.New;">
      <mat-icon>more_horiz</mat-icon>
    </button>

    <mat-menu #menu="matMenu">

      <button mat-menu-item
              *ngIf="(permissionService.hasShortcuts$ | async) && (permissionService.shortcuts$ | async).length > 0 && (permissionService.permissionNewActivity$ | async) === true"
              [class.disabled-button]="(faultsState$ | async).IsAnyFaultLocked || (faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsNewActivity"
              [mydocmaMenuTriggerFor]="shortcutMenu"
              (onMenuOpen)="onShortCutMenuOpen()"
              (onMenuClose)="shortCutMenuOpenState = false"
              (click)="onShortCutMenuClick($event); onMenuItemClick()"
              #matMenuShortcutsTrigger="mydocmaMenuTrigger"
              [disabled]="(faultsState$ | async).IsAnyFaultLocked || (faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsNewActivity">
        <mydocma-custom-mat-icon
          matTooltip="{{'MM.general.button.newActivity' | translate }} {{(faultsState$ | async).IsAnyFaultLocked ? lockedMessage() : ((faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsNewActivity ? lockedCountExceeded2(this.maxCountFaultsNewActivity) : '') }}"
          [iconName]="'_flag-2'"></mydocma-custom-mat-icon>
        {{  'MM.general.button.shortcuts' | translate }}
      </button>

      <mat-menu #shortcutMenu="matMenu">
        <button class="mat-menu-item" *ngFor="let sc of (permissionService.shortcuts$ | async)"
                (click)="addActivitiesByShortcut($event, sc);  onMenuItemClick()"
                [disabled]="(permissionService.permissionNewActivity$ | async) === false || (faultsState$ | async).IsAnyFaultLocked || (faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsNewActivity">
          <mydocma-custom-mat-icon [iconName]="IconName(sc)"></mydocma-custom-mat-icon>
          {{ sc.Status.Name1 + (sc.Status.Name2 ? ' - ' + sc.Status.Name2 : '') }}
        </button>
        <button class="mat-menu-item"
                matTooltip="{{'MM.general.button.newActivity' | translate }}"
                [class.disabled-button]="(faultsState$ | async).IsAnyFaultLocked || (faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsNewActivity"
                (click)="addActivitiesByShortcut(null,null); onMenuItemClick()"
                [disabled]="(permissionService.permissionNewActivity$ | async) === false || (faultsState$ | async).IsAnyFaultLocked || (faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsNewActivity">
          <mydocma-custom-mat-icon [iconName]="'_flag-2'"></mydocma-custom-mat-icon>
          {{  'MM.general.button.newActivity' | translate }}
        </button>
      </mat-menu>


      <button class="mat-menu-item" [disabled]="(faultsState$ | async).IsAnyFaultLocked || hasChanges() || (faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsWritings" [class.disabled-button]="(faultsState$ | async).IsAnyFaultLocked || hasChanges() || (faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsWritings" mat-menu-item
          (click)="writingService.startReportConfiguration(this.fault.project, [this.fault.data]); onMenuItemClick()">
        <mydocma-custom-mat-icon [iconName]="'_send-letter'"
                                 matTooltip="{{'MM.general.button.writing' | translate }} {{(faultsState$ | async).IsAnyFaultLocked ? lockedMessage() : ((faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsWritings ? lockedCountExceeded2(this.maxCountFaultsWritings) : '') }}"></mydocma-custom-mat-icon>
        {{'MM.general.button.writing' | translate }}
      </button>
      <button [disabled]="hasChanges()"[class.disabled-button]="hasChanges() || (faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsReports" mat-menu-item
         (click)="reportService.startReportConfiguration(this.fault.project, [this.fault.data]); onMenuItemClick()">
        <mydocma-custom-mat-icon fontSet="material-icons-outlined"
                                 matTooltip="{{'MM.reporting.report' | translate }} {{((faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsReports ? lockedCountExceeded2(this.maxCountFaultsReports) : '') }}"
                                 [iconName]="'description'"></mydocma-custom-mat-icon>
        {{'MM.reporting.report' | translate }}
      </button>
      <!--      <button [disabled]="hasChanges()" mat-menu-item>-->
      <!--        <mydocma-custom-mat-icon [iconName]="'_graph-report'"></mydocma-custom-mat-icon>-->
      <!--        {{'MM.general.button.report' | translate}}-->
      <!--      </button>-->
      <button [disabled]="(faultsState$ | async).IsAnyFaultLocked || (!deviceService.isTablet() && (rightPaneService.isUndocked$ | async))" [class.disabled-button]="(faultsState$ | async).IsAnyFaultLocked || (!deviceService.isTablet() && (rightPaneService.isUndocked$ | async))" *ngIf="fault?.pin && (permissionAddAttachment$ | async)" mat-menu-item
              (click)="faultActionsService.onPlanClipping(this.fault, this);  onMenuItemClick()">
        <mydocma-custom-mat-icon [iconName]="'_plan_modell_section'"></mydocma-custom-mat-icon>
        {{'MM.general.button.addPlanSection' | translate}}
      </button>
      <!--      <button [disabled]="hasChanges()" (click)="onSyncClick()" mat-menu-item>-->
      <!--        <mydocma-custom-mat-icon [iconName]="'_synchronize'"></mydocma-custom-mat-icon>-->
      <!--        {{'MM.general.button.synchronize' | translate }}-->
      <!--      </button>-->

      <button [disabled]="(faultsState$ | async).IsAnyFaultLocked || (rightPaneService.isUndocked$ | async)" [class.disabled-button]="(faultsState$ | async).IsAnyFaultLocked || (rightPaneService.isUndocked$ | async)" *ngIf="platformModeStateService.isLocalModeEnabled$ | async" mat-menu-item
              (click)="onFaultDownloadClick();  onMenuItemClick()">
        <mydocma-custom-mat-icon [iconName]="'_local_save'"></mydocma-custom-mat-icon>
        {{'MM.general.button.download' | translate}}
      </button>

      <button [disabled]="(faultsState$ | async).IsAnyFaultLocked || (rightPaneService.isUndocked$ | async)" [class.disabled-button]="(faultsState$ | async).IsAnyFaultLocked || (rightPaneService.isUndocked$ | async)" *ngIf="(platformModeStateService.isLocalModeEnabled$ | async) && this.fault?.downloaded" mat-menu-item
              (click)="onReloadAttachmentsClick()">
        <mydocma-custom-mat-icon [iconName]="'_attach_load'"></mydocma-custom-mat-icon>
        {{'MM.general.button.loadAllAttachments' | translate}}
      </button>

      <button [disabled]="(faultsState$ | async).IsAnyFaultLocked || (rightPaneService.isUndocked$ | async)" [class.disabled-button]="(faultsState$ | async).IsAnyFaultLocked || (rightPaneService.isUndocked$ | async)" *ngIf="(platformModeStateService.isLocalModeEnabled$ | async) && this.fault?.downloaded" mat-menu-item
              (click)="onRemoveFaultClick();  onMenuItemClick()">
        <mydocma-custom-mat-icon [iconName]="'_local_remove'"></mydocma-custom-mat-icon>
        {{'MM.general.button.removeDownload' | translate}}
      </button>

      <button [disabled]="(faultsState$ | async).IsAnyFaultLocked || hasChanges()" [class.disabled-button]="(faultsState$ | async).IsAnyFaultLocked || hasChanges()"
      *ngIf="!fault?.pin" (click)="faultActionsService.onLocatePinOnPlan(this.fault, this);  onMenuItemClick()" mat-menu-item>
        <mydocma-custom-mat-icon [iconName]="'_plan-view'"></mydocma-custom-mat-icon>
        {{'MM.general.button.locateOnPlan' | translate }}
      </button>

      <button mat-menu-item (click)="addToPool();  onMenuItemClick()"
              [disabled]="(changeService.changesPerMask.get(faultRightPane) | async)"
              *ngIf="(permissionDefectPoolsAddDefects$ | async)">
        <mydocma-custom-mat-icon fontSet="material-icons-outlined" [iconName]="'_defect_pool_add'"></mydocma-custom-mat-icon>
        {{'MM.general.button.addToPool' | translate }}

      </button>
      <button mat-menu-item (click)="removeFromPool();  onMenuItemClick()"
              [disabled]="(changeService.changesPerMask.get(faultRightPane) | async)"
              *ngIf="(permissionDefectPoolsRemoveDefects$ | async)">
        <mydocma-custom-mat-icon fontSet="material-icons-outlined" [iconName]="'_defect_pool_remove'"></mydocma-custom-mat-icon>
        {{'MM.general.button.removeFromPool' | translate }}
      </button>

      <button [disabled]="(faultsState$ | async).IsAnyFaultLocked || hasChanges()"
              [class.disabled-button]="(faultsState$ | async).IsAnyFaultLocked || hasChanges()"
              *ngIf="permissionDuplicateFault$ | async" mat-menu-item
              (click)="onDuplicateClick(); onMenuItemClick()">
        <mydocma-custom-mat-icon fontSet="material-icons-outlined" [iconName]="'content_copy'"></mydocma-custom-mat-icon>
        {{'MM.fault.duplicate.button' | translate }}
      </button>

      <button [disabled]="(faultsState$ | async).IsAnyFaultLocked || hasChanges() || (faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsNewActivity" [class.disabled-button]="(faultsState$ | async).IsAnyFaultLocked || hasChanges() || (faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsDelete" *ngIf="!(platformModeStateService.isLocalMode$ | async) && permissionDelete$ | async" mat-menu-item
        (click)="faultActionsService.onDeleteClick([this.fault]);  onMenuItemClick()">
        <mydocma-custom-mat-icon [iconName]="'_delete'"
                                 matTooltip="{{'MM.general.button.delete' | translate }} {{(faultsState$ | async).IsAnyFaultLocked ? lockedMessage() : ((faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsDelete ? lockedCountExceeded2(this.maxCountFaultsDelete) : '') }}"></mydocma-custom-mat-icon>
        {{'MM.general.button.delete' | translate }}
      </button>
      <button [disabled]="(faultsState$ | async).IsAnyFaultLocked || hasChanges()" [class.disabled-button]="(faultsState$ | async).IsAnyFaultLocked || hasChanges()"
              *ngIf="!(platformModeStateService.isLocalMode$ | async) && fault?.pin && (permissionDeletePins$ | async) && (((faultsSplitService.rightViewVisible$ | async) || deviceService.isMobil()) || isPaneUndocked)"
              mat-menu-item (click)="onDeletePin(); onMenuItemClick()">
        <mydocma-custom-mat-icon [iconName]="'_pin-delete'"></mydocma-custom-mat-icon>
        {{'MM.plan.removePin' | translate }}
      </button>

      <button mat-menu-item (click)="onOpenFieldConfiguration();  onMenuItemClick()"
              [disabled]="(changeService.changesPerMask.get(faultRightPane) | async)">
        <mydocma-custom-mat-icon [iconName]="'settings'"></mydocma-custom-mat-icon>
        {{'MM.general.button.field-settings' | translate }}

      </button>

   </mat-menu>
  </div>
</mydocma-mm-app-pane-header>

<div class="mm-pane-body" mydocmaResizeEvent (resize)="onResize($event)">
  <mydocma-loader *ngIf="(mmFaultDetailsService.onFaultLoading | async)
                          || (faultsViewService.loadingState | async)
                          || (faultViewService.faultLoading$ | async)
                          || (fault?.loadState?.status === loadStatus.Loading)
                          || (triggerLoader$ | async)
                          || (faultFieldMemoryService.memoryValuesLoading$ | async)
                          || (rightPaneService.saving$ | async)
                          || (fieldConfigurationService.loading$ | async)" class="mydocma-mm-loader">
  </mydocma-loader>
  <!--  <mydocma-loader *ngIf="(faultViewService.faultLoading$ | async)" class="mydocma-mm-loader"></mydocma-loader>-->

  <mat-tab-group
    (selectedTabChange)="onSelectedTabChange($event)"
    #tabGroup style="height: 100%;" [(selectedIndex)]="tabIndex" animationDuration="0ms" class="mydocma-tab-group">
    <mat-tab #firstTab>
      <ng-template mat-tab-label>
        <mat-icon>format_align_left</mat-icon>
        <span *ngIf="showTabTexts">Details</span>
        <sup *ngIf="faultFormValid == false && showTabTexts" style="margin-bottom: 10px; color:red;">*</sup>
      </ng-template>

      <div class="tab-container">
        <mydocma-mm-fault-detail-form #detailForm
                                      [active]="tabIndex === 0"
                                      (onFormReady)="onFormReady($event)"
                                      (faultFormValidEvent)="setFormState($event)" [faultItem]="fault"
                                      [isLocked]="isLocked">
        </mydocma-mm-fault-detail-form>
      </div>
    </mat-tab>

    <mat-tab #activitiesTab>
      <ng-template mat-tab-label>
        <mat-icon>outlined_flag</mat-icon>
        <span *ngIf="showTabTexts">{{'MM.activity.activities' | translate }}</span>
      </ng-template>

      <ng-template matTabContent>
        <div class="tab-container">
          <mydocma-mm-fault-activities [fault]="fault" [isLocked]="isLocked">
          </mydocma-mm-fault-activities>
        </div>
      </ng-template>
    </mat-tab>


    <mat-tab *ngIf="costsTabVisible$ | async">
      <ng-template mat-tab-label>
        <mydocma-custom-mat-icon fontSet="material-icons-outlined" [iconName]="'euro'"></mydocma-custom-mat-icon>
        <span *ngIf="showTabTexts">{{'MM.cost.costPlural' | translate }}</span>
      </ng-template>

      <ng-template matTabContent>
        <div class="tab-container">
          <mydocma-mm-fault-costs [fault]="fault"></mydocma-mm-fault-costs>
        </div>
      </ng-template>
    </mat-tab>


    <mat-tab #attachmentsTab>
      <ng-template mat-tab-label>
        <mat-icon>attach_file</mat-icon>
        <span *ngIf="showTabTexts">{{'MM.attachment.attachments' | translate }}</span>
        <span class="mm-tab-counter"
              *ngIf="(appContainerService.mobileView$ | async) && fault?.isNew && newAttachmentsCount > 0">{{newAttachmentsCount}}</span>
      </ng-template>

      <ng-template matTabContent>
        <div class="tab-container">
          <div>
            <mydocma-top-actions class="mydocma-mm-at-top-actions top-actions mydocma-mm-actions-bar"
                                 *ngIf="(permissionAddAttachment$ | async)">
              <div #ref actions-bar-content class="mm-fault-pane-actions-bar-content">
                <mydocma-new-fab class="mydocma-mm-action-new" [button]="fabButton">
                </mydocma-new-fab>

                <div class="mydocma-mm-top-actions-sort-container" ap-pane-menu>
                  <button style="font: small-caption" type="button" cdkOverlayOrigin #trigger="cdkOverlayOrigin" mat-icon-button
                    [mydocmaMenuTriggerFor]="sortAttachmentMenu"
                    #parentMenuTrigger="mydocmaMenuTrigger"
                    matTooltip="{{'MM.attachment.sortBy' | translate }}"  >
                    <mydocma-custom-mat-icon [iconName]="'sort'"></mydocma-custom-mat-icon>
                  </button>

                  <mat-menu #sortAttachmentMenu="matMenu">
                    <div style="min-width: 170px;">
                      <button mat-menu-item class="sort-criteria-item"
                        (click)="onAttachmentsSortingSelect(attachmentSortingEnum.FileDate)">
                        <span class="sort-criteria-item-text">
                          {{'MM.attachment.date' | translate }}
                        </span>
                        <mydocma-custom-mat-icon fontSet="material-icons-outlined"
                          *ngIf="selectedAttachmentSorting === attachmentSortingEnum.FileDate" [iconName]="'check'"
                          class="sort-criteria-item-icon"></mydocma-custom-mat-icon>
                      </button>

                      <button (click)="onAttachmentsSortingSelect(attachmentSortingEnum.AddedOn)" mat-menu-item
                        class="sort-criteria-item">
                        <span class="sort-criteria-item-text">{{'MM.attachment.createdOn' | translate }}</span>
                        <mydocma-custom-mat-icon fontSet="material-icons-outlined" [iconName]="'check'" class="sort-criteria-item-icon"
                          *ngIf="selectedAttachmentSorting === attachmentSortingEnum.AddedOn"></mydocma-custom-mat-icon>
                      </button>
                      <div class="sort-divider"></div>

                      <button (click)="onAttachmentsSortingTypeSelect(attachmentSortingTypeEnum.Ascending)" mat-menu-item
                        class="sort-criteria-item">
                        <span class="sort-criteria-item-text">
                          {{'MM.attachment.ascending' | translate }}

                        </span>
                        <mydocma-custom-mat-icon fontSet="material-icons-outlined" [iconName]="'check'" class="sort-criteria-item-icon"
                          *ngIf="selectedAttachmentSortingType === attachmentSortingTypeEnum.Ascending"></mydocma-custom-mat-icon>
                      </button>
                      <button (click)="onAttachmentsSortingTypeSelect(attachmentSortingTypeEnum.Descending)" mat-menu-item
                        class="sort-criteria-item">
                        <span class="sort-criteria-item-text">
                          {{'MM.attachment.descending' | translate }}
                        </span>
                        <mydocma-custom-mat-icon fontSet="material-icons-outlined" [iconName]="'check'" class="sort-criteria-item-icon"
                          *ngIf="selectedAttachmentSortingType === attachmentSortingTypeEnum.Descending"></mydocma-custom-mat-icon>
                      </button>
                    </div>

                </mat-menu>
                  </div>

              </div>
            </mydocma-top-actions>
            <div class="attachments-list">
              <mydocma-mm-fault-attachments [fault]="fault" [sorting]="selectedAttachmentSorting" [sortingType]="selectedAttachmentSortingType">
              </mydocma-mm-fault-attachments>
            </div>
          </div>
        </div>

      </ng-template>
    </mat-tab>
  </mat-tab-group>

</div>
<div
  class="mobile-pane-footer mm-pane-footer"
  *ngIf="
  (appContainerService.mobileView$ | async)
   || isPaneUndocked">
  <div style="margin-right: 16px">
    <button mat-stroked-button class="mydocma-btn" [class.dv-back-button]="(this.planEditService.planEditMode === planEditModeEnum.Edit)" (click)="onCloseOrBackClick()" [disabled]="(rightPaneService.saving$ | async)">
      <mat-icon *ngIf="this.planEditService.planEditMode === planEditModeEnum.Edit">chevron_left</mat-icon>
      {{ (this.planEditService.planEditMode === planEditModeEnum.Edit)
        ? ('MM.general.button.back' | translate)
        : (((rightPaneService.saving$ | async) || !(((changeService.changesPerMask.get(faultRightPane) | async) || (changeService.changesPerMask.get(planRightPane) | async))))
          ? ('MM.general.button.close' | translate)
          : ('MM.general.button.cancel' | translate))
      }}
    </button>
  </div>
  <div style="margin-right: 16px;" class="mm-footer-add-wrap"
       *ngIf="(permissionService.permissionNewActivity$ | async) || (permissionAddAttachment$ | async)">
    <button mat-stroked-button class="mydocma-btn mydocma-btn-secondary mm-footer-add-btn"
            [disabled]="(rightPaneService.saving$ | async) || (faultsState$ | async).IsAnyFaultLocked"
            [mydocmaMenuTriggerFor]="mobileAddMenu">
      <mat-icon>add</mat-icon>
    </button>
  </div>
  <div>
    <button mat-stroked-button class="mydocma-btn-primary" (click)="onDoneClick()"
          [disabled]="(rightPaneService.saving$ | async) || (rightPaneService.donePressed$ | async) || (triggerLoader$ | async) || !(((changeService.changesPerMask.get(faultRightPane) | async) || (changeService.changesPerMask.get(planRightPane) | async)) && !(((plansManagerService.selectedPlan$ | async) == null) && (planEditService.planEditMode$ | async) === 3))">
          <mat-icon>done</mat-icon>
          {{'MM.general.button.save' | translate}}
    </button>
  </div>
</div>

<mat-menu #mobileAddMenu="matMenu">
  <button mat-menu-item
          *ngIf="(permissionService.permissionNewActivity$ | async) && ((permissionService.shortcuts$ | async)?.length > 0)"
          [disabled]="(faultsState$ | async).IsAnyFaultLocked"
          [mydocmaMenuTriggerFor]="mobileShortcutsMenu">
    <mydocma-custom-mat-icon [iconName]="'_flag-2'"></mydocma-custom-mat-icon>
    {{'MM.fault.mobileAddMenu.activity' | translate}}
  </button>
  <button mat-menu-item
          *ngIf="(permissionService.permissionNewActivity$ | async) && !((permissionService.shortcuts$ | async)?.length > 0)"
          [disabled]="(faultsState$ | async).IsAnyFaultLocked"
          (click)="addActivitiesByShortcut(null, null)">
    <mydocma-custom-mat-icon [iconName]="'_flag-2'"></mydocma-custom-mat-icon>
    {{'MM.fault.mobileAddMenu.activity' | translate}}
  </button>
  <button mat-menu-item
          *ngIf="(permissionAddAttachment$ | async) && ((appContainerService.mobileView$ | async) || deviceService.isMobil())"
          [disabled]="(faultsState$ | async).IsAnyFaultLocked"
          (click)="newAttachmentFromCamera()">
    <mydocma-custom-mat-icon [iconName]="'photo_camera'" fontSet="material-icons-outlined"></mydocma-custom-mat-icon>
    {{'MM.fault.mobileAddMenu.camera' | translate}}
  </button>
  <button mat-menu-item
          *ngIf="permissionAddAttachment$ | async"
          [disabled]="(faultsState$ | async).IsAnyFaultLocked"
          (click)="onPhotosPicked()">
    <mydocma-custom-mat-icon [iconName]="'image'" fontSet="material-icons-outlined"></mydocma-custom-mat-icon>
    {{'MM.fault.mobileAddMenu.photos' | translate}}
  </button>
  <button mat-menu-item
          *ngIf="permissionAddAttachment$ | async"
          [disabled]="(faultsState$ | async).IsAnyFaultLocked"
          (click)="newAttachmentFromFile()">
    <mydocma-custom-mat-icon [iconName]="'folder'" fontSet="material-icons-outlined"></mydocma-custom-mat-icon>
    {{'MM.fault.mobileAddMenu.files' | translate}}
  </button>
  <button mat-menu-item
          *ngIf="(permissionAddAttachment$ | async) && ((pixService.availableProjects$ | async)?.length > 0)"
          [disabled]="(faultsState$ | async).IsAnyFaultLocked"
          (click)="newAttachmentFromPix()">
    <mydocma-custom-mat-icon [iconName]="'_app-px'"></mydocma-custom-mat-icon>
    {{'MM.fault.mobileAddMenu.pix' | translate}}
  </button>
  <button mat-menu-item
          *ngIf="fault?.pin && (permissionAddAttachment$ | async)"
          [disabled]="(faultsState$ | async).IsAnyFaultLocked"
          (click)="faultActionsService.onPlanClipping(this.fault, this)">
    <mydocma-custom-mat-icon [iconName]="'_plan_modell_section'"></mydocma-custom-mat-icon>
    {{'MM.fault.mobileAddMenu.planSection' | translate}}
  </button>
  <button mat-menu-item
          *ngIf="!fault?.pin"
          [disabled]="(faultsState$ | async).IsAnyFaultLocked || hasChanges()"
          (click)="faultActionsService.onLocatePinOnPlan(this.fault, this)">
    <mydocma-custom-mat-icon [iconName]="'_plan-view'"></mydocma-custom-mat-icon>
    {{'MM.fault.mobileAddMenu.planSection' | translate}}
  </button>
</mat-menu>

<mat-menu #mobileShortcutsMenu="matMenu">
  <button mat-menu-item *ngFor="let sc of (permissionService.shortcuts$ | async)"
          (click)="addActivitiesByShortcut($event, sc)">
    <mydocma-custom-mat-icon [iconName]="IconName(sc)"></mydocma-custom-mat-icon>
    {{ sc.Status.Name1 + (sc.Status.Name2 ? ' - ' + sc.Status.Name2 : '') }}
  </button>
  <button mat-menu-item (click)="addActivitiesByShortcut(null, null)">
    <mydocma-custom-mat-icon [iconName]="'_flag-2'"></mydocma-custom-mat-icon>
    {{'MM.general.button.newActivity' | translate}}
  </button>
</mat-menu>


